<template>
  <div class="d-flex mt-4">
    <v-icon color="blue">mdi-card-text-outline</v-icon>
    <p v-linkify class="mb-0 ml-2 text-body-1 blue--text overflow-hidden">
      {{ $sanitize(response, { allowedTags: ['a'] }) }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'Response',

  props: {
    response: [String, Number, Array],
  },
}
</script>
